module.exports = __webpack_public_path__ + "img/CNN-LOGO.ec3b41e8.svg";